export default __webpack_public_path__ + "static/media/goal-announcement.2aa69551.svg";